import { SET_KEEP_SESSION } from '../../../constants';

export const setKeepSession = (keepSession: boolean) => ({
  type: SET_KEEP_SESSION,
  payload: { keepSession },
});
